import { Loader2 } from "lucide-react";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";

interface SettingsTableProps {
  colSpan?: number;
  isLoading?: boolean;
  isEmpty?: boolean;
  emptyMessage?: string;
  children?: React.ReactNode;
}

export function SettingsTable({
  colSpan = 1,
  isLoading,
  isEmpty,
  emptyMessage = "No items yet.",
  children,
}: SettingsTableProps) {
  return (
    <div className="rounded-md border border-[color:var(--color-border)] overflow-hidden bg-[color:var(--color-surface)]">
      <Table>
        {isLoading ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={colSpan} className="text-center py-8">
                <Loader2 className="mx-auto h-5 w-5 animate-spin text-[color:var(--color-text-lo)]" />
              </TableCell>
            </TableRow>
          </TableBody>
        ) : isEmpty ? (
          <TableBody>
            <TableRow>
              <TableCell
                colSpan={colSpan}
                className="text-center py-8 typo-body text-[color:var(--color-text-lo)]"
              >
                {emptyMessage}
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          children
        )}
      </Table>
    </div>
  );
}
